export default "__VITE_ASSET__BbGiPZm3__"